import { genComponentStyleHook, type FullToken } from '../geek/styleUtil'
import { purple, transition, getGlassStyle } from './glowUtil'
import { DOT_PREFIX } from './constant'

export default genComponentStyleHook(['Modal', 'heroTheme'], (token: FullToken) => {
  const { componentCls } = token
  const isDark = token.colorBgLayout === '#18181b'

  return {
    [`${componentCls}${DOT_PREFIX}`]: {
      [`${componentCls}-content`]: {
        ...getGlassStyle(isDark),
        borderRadius: 18,
        border: `1px solid ${isDark ? purple[800] + '40' : purple[200] + '60'}`,
        boxShadow: `0 20px 60px ${purple[900]}15, 0 0 40px ${purple[600]}08`,
        // Keep content padding at 0; spacing is centralized in `global.less`.
        padding: 0,
        overflow: 'hidden',
      },

      [`${componentCls}-header`]: {
        background: 'transparent',
        borderBottom: 'none',
        '&:after': {
          content: '""',
          display: 'block',
          marginTop: 8,
          height: 1,
          background: `linear-gradient(90deg, ${purple[500]}30, transparent)`,
        },
      },

      [`${componentCls}-close`]: {
        transition,
        borderRadius: 8,
        '&:hover': {
          background: `${purple[500]}15 !important`,
          color: `${purple[500]} !important`,
        },
      },
    },
  }
})
